













import {
  useContactData,
  useLocalFilter,
  useMapMasterTypeToOptionAlt,
} from "@/hooks";
import { Option } from "@/models/class/option.class";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectSupplierType extends Vue {
  useLocalFilter = useLocalFilter;

  @Prop({ required: true, type: String, default: "" }) value!: string;

  options: Option[] = [];
  loading = false;

  created(): void {
    this.fetchData();
  }

  emits(e: string): void {
    this.$emit("input", e);
  }

  fetchData(): void {
    const { findAllSupplierType } = useContactData();
    this.loading = true;
    findAllSupplierType()
      .then(res => {
        this.options = useMapMasterTypeToOptionAlt(res);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
